export default __webpack_public_path__ + "static/media/How it works dark.8307d075.svg";